import { Component, OnInit, ViewChild, ViewChildren, ElementRef, Input, ChangeDetectorRef, ChangeDetectionStrategy, QueryList, Directive } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { NgxMoveableComponent } from "ngx-moveable";
import { fabric } from 'fabric';
import { Frame } from 'scenejs';
import { Observable, Subject, Subscription } from 'rxjs';
import { SeoService } from '../../services/seo.service';
@Directive({selector: 'ngx-moveable'})
class NgxMoveableDirective {
  updateRect: any;
}

@Component({
  selector: 'app-wizard-image-controller',
  templateUrl: './wizard-image-controller.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-image-controller.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardImageControllerComponent extends WizardHpBaseComponent implements OnInit {
  @Input() isFlippedHorizontally = false;
  @Input() isFlippedHorizontallyMulti = [];
  @Input() isExterior = true;
  @Input() target_area_selected = false;
  @Input() target_area_index = 0;
  @Input() answerProgress = false;
  @Input() inReverseExt = false;
  @Input() warpable = false;
  @Input() mapDraggable = false;
  @Input() mapResizable   = false;
  @Input() mobileTarget  :number; 
  @Input() visualType  :any; 
  @Input() productsFrames  :any = []; 
  @Input() transformCss_w  :any = [];  
  @Input() eventUpdateReact: Observable<void>;
  @Input() warpable_product = false;
  @Input() warpable_index =-1;
  @Input() productsGlobalDtata:any = [];
  @Input() multiGlobaldata:any ;
  @Input() showMultiProduct = false;
  @Input() list_catalog :any
  @Input()eventsSubject:Subject<void>;
  @Input() isExteriror = true;
  @Input() isLoading = false;
  @Input() switchViewLoading = false;
  @Input() isMultiProduct= false;
  @Input()  bounds: any = {"left":0,"top":0,"right":0,"bottom":0,"position":"css"};  
  resizable: any = true;
  
  @ViewChild("moveable", { static: false }) moveable;
  @ViewChild("moveableMap", { static: false }) moveableMap;
  @ViewChild("moveableViewExt", { read: ElementRef, static: false }) moveableViewExt: NgxMoveableComponent;
  @ViewChildren("moveableProducts") moveableProducts!: QueryList<NgxMoveableDirective>;
  @ViewChild("target", { static: false }) target: NgxMoveableComponent;
  @ViewChild("multiTarget", { static: false }) multiTarget: NgxMoveableComponent;
  @ViewChild("mapTarget", { static: false }) mapTarget: NgxMoveableComponent;
  private eventsSubscription: Subscription;
  frameMap: any;
  warpMatrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
  matrix3dTierce = [1.5, 0.00537634, 0, 1.29032e-20, -1.99295e-17, 1, 0, -4.43804e-19, 0, 0, 1, 0, 35.0001, 0.5, 0, 1];
  matrix3dDoubleT = [2.12945, 2.06476e-09, 0, 3.46945e-18, 1.35325e-17, 1, 0, -5.15975e-19, 0, 0, 1, 0, 76.0001, 1.56934e-07, 0, 1];
  matrix3dLarge = [1.26882, -9.86989e-10, 0, 8.38389e-32, 5.36792e-24, 1, 0, -2.1684e-19, 0, 0, 1, 0, 25, -9.17895e-08, 0, 1];
  starWrap = true;
  starWrapInt = true;
  warpableViewStreet = false;
  draggableViewStreet = false;
   view: string; 
  porteExtId: any;
  porteIntId: any;
  domExt; 
  domInt;
  canvasExt: any;
  canvasInt: any;
  container : any;
  navListCatalog : any;
  mapGoogleKey:any;
  dataMap = {
    "visible": 0,
    "linkposition": "46.98123233164222,1.805750207787383",
    "heading": 108.76767031965346,
    "pitch": 2.8858925347222737,
    "fov": 159
  };

  frames = new Frame({
    left: '60%',
    top: '20%',
    transform: {
      rotate: '0deg',
      scaleX: 1,
      scaleY: 1,
      matrix3d: this.warpMatrix,
    },
  });
  frameInt = new Frame({
    left: '60%',
    top: '20%',
    transform: {
      rotate: '0deg',
      scaleX: 1,
      scaleY: 1,
      matrix3d: this.warpMatrix,
    }
  });
  globalData :any;
  listCatalog:any;
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent,
    hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);
    this.globalData =  this.getHpService().getMultiGlobaldata();
    if(this.getHpService().getConfig().herculepro.multiProduct)
    {
      this.navListCatalog = this.getHpService().getListCataglog();
    }
    
    this.mapGoogleKey = this.getHpService().getConfig().data_googleMap.key;
    
    
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getHpService().emitDataChange();
 
           
    }
  
    public getMultiGlobaldata()
    {
      this.multiGlobaldata = this.getHpService().getMultiGlobaldata();
    }
 
    setShowMultiproduct(bool)
    {

      this.getSimulateur().setShowMultiproduct(bool);
    }
    public updateImagesRect() {
    if (this.moveable) {
      this.moveable.updateRect();
    }

  }

  public updateProductReact()
  {
    if(this.moveableProducts)
    {
      this.moveableProducts.forEach(div =>{
        div.updateRect()
      } );

    }
  
  }
  public updateMapImagesRect() {
    if (this.moveableMap) {
      this.moveableMap.updateRect();
    }

  }
 
  getBackDomElId() {
    if (this.isExterior) {
      return "imageExt";
    } else {
      return "imageInt";
    }
  }

  getBackDomElClass() {
    return this.getBackDomElId();
  }

  getIsInterior() {
    return this.isExterior;
  }

  getCanvasId() {
    if (this.isExterior) {
      return "canvasExt";
    } else {
      return "canvasExt";
    }
  }

  getTargetMobileId() {
    if (this.isExterior) {
      return "target-mobile";
    } else {
      return "target-mobile-int";
    }
  }

  
  getTargetMobileClass() {
    if (this.isExterior) {
      return "targetMobile";
    } else {
      return "targetMobileInt";
    }
  }

  getCanvasDisplay() {
    return 'block';
    /*
    if (this.isExterior) {
      return (this.getSimulateur().getVisualExtSelected() === 'view-0' || this.getSimulateur().getVisualExtSelected() === 'upload-0' ? 'block': 'block');
    } else {
      return (this.getSimulateur().getVisualExtSelected() === 'view-0' || this.getSimulateur().getVisualExtSelected() === 'upload-0' ? 'block': 'block');
    }
    */
  }

  getVisualTargetId() {
    if (this.isExterior) {
      return "target";
    } else {
      return "targetInt";
    }
  }

  getVisualTargetClass() {
    if (this.isExterior) {
      return "target";
    } else {
      return "target target-in";
    }
  }

  getVisualTargetImgId() {

    if (this.isExterior) {
      return "idImgext";
    } else {
      return "idImgint";
    }
  }

  getMoveableTarget() {
    return this.getVisualTargetId();
  }
  
 getProductsFrames()
 {
   return this.getSimulateur().getProductFrames();
 } 
 
 getProductImage(item:any,i)
 {
  if(this.getHpService().getCloneControle() && this.globalData )
    {
      return this.getHpService().getCloneControle()[i].isClone ? this.globalData[this.getHpService().getCloneControle()[i].parentIndex].root.drawing.value : item.root.drawing.value

    }
   }

showProductsViewIn(i)
{
 if( this.list_catalog && this.list_catalog.length > 0)
    {
      let view = this.isExterior ? "0" : "1";
      let navCtalog_index = this.list_catalog[i].navCat_index;
      return this.navListCatalog[navCtalog_index].viewOutIn[view];
    }
 
}

}
